import Topics from './Topics';

export default Topics;
